<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div v-if="isReferrals && !isDisabled && isCancelClick">
      <div class="grid line-text mt-5">
        <div class="col-12 lg:col-4 custom-control">
          <Checkbox
            :binary="true"
            v-model="vmodel1.setAmbassadorInfoInFriendLink"
            id="showdeniedoutofcodemsg"
            type="checkbox"
          />
          <label
            for="showdeniedoutofcodemsg"
            class="ml-2 checkbox-radio-font"
            id="showdeniedoutofcodemsg-tooltip"
            v-tooltip="lmodel.setAmbassadorInfoInFriendLinkToolTip"
            >{{ lmodel.setAmbassadorInfoInFriendLink }}</label
          >
        </div>
        <div class="col-12 lg:col-4 custom-control">
          <Checkbox
            :binary="true"
            v-model="vmodel1.ambfrndlnkexp"
            id="showdeniedoutofcodemsg"
            type="checkbox"
          />
          <label
            for="showdeniedoutofcodemsg"
            class="ml-2 checkbox-radio-font"
            id="showdeniedoutofcodemsg-tooltip"
            >{{ lmodel.ambFriendLinkExpire }}</label
          >
        </div>
        <div class="col-12 lg:col-4 custom-control">
          <Checkbox
            :binary="true"
            v-model="vmodel1.setAnimateDealSetting"
            id="showdeniedoutofcodemsg"
            type="checkbox"
          />
          <label
            for="showdeniedoutofcodemsg"
            class="ml-2 checkbox-radio-font"
            id="showdeniedoutofcodemsg-tooltip"
            v-tooltip="lmodel.setAnimateDealSettingToolTip"
            >{{ lmodel.setAnimateDealSetting }}</label
          >
        </div>

        <div class="grid col-12">
          <div class="col-12 lg:col-4 custom-control">
            <Checkbox
              :binary="true"
              v-model="vmodel1.setEnableUTMTags"
              id="showdeniedoutofcodemsg"
              type="checkbox"
            />
            <label
              for="showdeniedoutofcodemsg"
              class="ml-2 checkbox-radio-font"
              id="showdeniedoutofcodemsg-tooltip"
              v-tooltip="lmodel.setEnableUTMTagsToolTip"
              >{{ lmodel.setEnableUTMTags }}</label
            >
          </div>
          <div class="col-12 lg:col-4 custom-control">
            <Checkbox
              :binary="true"
              v-model="vmodel1.ambDisFriendFlow"
              id="showdeniedoutofcodemsg"
              type="checkbox"
            />
            <label
              for="showdeniedoutofcodemsg"
              class="ml-2 checkbox-radio-font"
              id="showdeniedoutofcodemsg-tooltip"
              v-tooltip="lmodel.ambassadorDisableFriendFlowToolTip"
              >{{ lmodel.ambassadorDisableFriendFlow }}</label
            >
          </div>
        </div>
        <div class="grid col-12">
          <div class="col-12 lg:col-6">
            <label
              for="AmbFlowType"
              class="control-labeladd"
              v-tooltip="lmodel.ambFlowTypeToolTip"
              >{{ lmodel.ambFlowType }}</label
            >
            <DropDownRequire
              :validation="valmodel.ambFlowType"
              v-model="vmodel1.ambFlowType"
              :options="dmodel.ambassadorFriend.ambassadorFlowType"
              PropName="Flow Type"
              id="FlowType"
              class="mt-2 w-full"
              optionLabel="text"
              optionValue="value"
              dropdownIcon="fa fa-sort"
              editable
            ></DropDownRequire>
          </div>
          <div class="col-12 lg:col-6 custom-control mt-5">
            <Checkbox
              :binary="true"
              v-model="vmodel1.ambContactInfoAsUrlParam"
              id="showdeniedoutofcodemsg"
              type="checkbox"
            />
            <label
              for="showdeniedoutofcodemsg"
              class="ml-2 checkbox-radio-font"
              id="showdeniedoutofcodemsg-tooltip"
              v-tooltip="lmodel.ambContactInfoAsUrlToolTip"
              >{{ lmodel.ambContactInfoAsUrl }}</label
            >
          </div>
        </div>
        <div class="grid col-12">
          <div class="col-12 lg:col-12 mt-2">
            <span class="general-settings-label">
              {{ lmodel.setDealChannel }}
            </span>
            <br />
            <span class="general-settings-text">
              {{ lmodel.setDealChannelHelpText }}
            </span>
          </div>
        </div>
        <div class="grid col-12">
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowFacebookChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasFacebookChannel"
              id="hasFacebookChannel"
              type="checkbox"
            />
            <label
              for="Messenger"
              class="ml-2 checkbox-radio-font"
              id="messenger-tooltip"
              >{{ lmodel.setMessenger }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowMailChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasNativeMailChannel"
              id="hasNativeMailChannel"
              type="checkbox"
            />
            <label
              for="NativeMail"
              class="ml-2 checkbox-radio-font"
              id="nativeMail-tooltip"
              >{{ lmodel.setNativeMail }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.showSMSChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasNativeSmsChannel"
              id="setNativeSMS"
              type="checkbox"
            />
            <label
              for="SetNativeSMS"
              class="ml-2 checkbox-radio-font"
              id="setNativeSMS-tooltip"
              >{{ lmodel.setNativeSMS }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowTrueCallerChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasTrueCallerChannel"
              id="hasTrueCallerChannel"
              type="checkbox"
            />
            <label
              for="TrueCaller"
              class="ml-2 checkbox-radio-font"
              id="trueCaller-tooltip"
              >{{ lmodel.setTrueCaller }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowWhatsappChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasWhatsappChannel"
              id="whatsapp"
              type="checkbox"
            />
            <label
              for="Whatsapp"
              class="ml-2 checkbox-radio-font"
              id="whatsapp-tooltip"
              >{{ lmodel.setWhatsapp }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowSharebleLinkChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasSharebleLinkChannel"
              id="sharebleLink"
              type="checkbox"
            />
            <label
              for="SharebleLink"
              class="ml-2 checkbox-radio-font"
              id="sharebleLink-tooltip"
              >{{ lmodel.setSharebleLink }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowTwitterChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasTwitterChannel"
              id="twitter"
              type="checkbox"
            />
            <label
              for="Twitter"
              class="ml-2 checkbox-radio-font"
              id="twitter-tooltip"
              >{{ lmodel.setTwitter }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowTelegramChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasTelegramChannel"
              id="telegram"
              type="checkbox"
            />
            <label
              for="Telegram"
              class="ml-2 checkbox-radio-font"
              id="telegram-tooltip"
              >{{ lmodel.setTelegram }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowLineChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasLineChannel"
              id="line"
              type="checkbox"
            />
            <label
              for="Line"
              class="ml-2 checkbox-radio-font"
              id="line-tooltip"
              >{{ lmodel.setLine }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowKakaotalkChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasKakaotalkChannel"
              id="kakaotalk"
              type="checkbox"
            />
            <label
              for="Kakaotalk"
              class="ml-2 checkbox-radio-font"
              id="kakaotalk-tooltip"
              >{{ lmodel.setKakaotalk }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowWebShareChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasWebShareChannel"
              id="webShare"
              type="checkbox"
            />
            <label
              for="WebShare"
              class="ml-2 checkbox-radio-font"
              id="webShare-tooltip"
              >{{ lmodel.setWebShare }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowQRLinkChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasQRChannel"
              id="qr"
              type="checkbox"
            />
            <label for="QR" class="ml-2 checkbox-radio-font" id="qr-tooltip">{{
              lmodel.setQR
            }}</label>
          </div>

          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.showPageShareChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasPageShareChannel"
              id="pageShare"
              type="checkbox"
            />
            <label
              for="PageShare"
              class="ml-2 checkbox-radio-font"
              id="pageShare-tooltip"
              >{{ lmodel.setPageShare }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowSkypeChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasSkypeChannel"
              id="skype"
              type="checkbox"
            />
            <label
              for="Skype"
              class="ml-2 checkbox-radio-font"
              id="skype-tooltip"
              >{{ lmodel.setSkype }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.showWeChatChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasWeChatChannel"
              id="weChat"
              type="checkbox"
            />
            <label
              for="WeChat"
              class="ml-2 checkbox-radio-font"
              id="weChat-tooltip"
              >{{ lmodel.setWeChat }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowInstagramChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasInstagramChannel"
              id="instagram"
              type="checkbox"
            />
            <label
              for="Instagram"
              class="ml-2 checkbox-radio-font"
              id="instagram-tooltip"
              >{{ lmodel.setInstagram }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowDiscordChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasDiscordChannel"
              id="discord"
              type="checkbox"
            />
            <label
              for="Discord"
              class="ml-2 checkbox-radio-font"
              id="discord-tooltip"
              >{{ lmodel.setDiscord }}</label
            >
          </div>
          <div
            class="col-12 lg:col-4 custom-control"
            v-if="vmodel1.setShowSignalChannelOption"
          >
            <Checkbox
              :binary="true"
              v-model="vmodel1.setHasSignalChannel"
              id="signal"
              type="checkbox"
            />
            <label
              for="Signal"
              class="ml-2 checkbox-radio-font"
              id="signal-tooltip"
              >{{ lmodel.setSignal }}</label
            >
          </div>
        </div>
        <div class="grid col-12">
          <div class="col-12 lg:col-12">
            <span class="general-settings-text">
              {{ staticData.referrals.channelsbutton }}
            </span>
            <br />
            <span class="general-settings-text">
              {{ staticData.referrals.selectchannels }}
            </span>
          </div>
        </div>
        <div class="grid col-12">
          <div class="col-12 lg:col-6 custom-control">
            <RadioButton
              v-model="ambDisplayButton"
              id="displayCTAbuttons"
              type="radio"
              value="0"
              :disabled="!isAnyChannelEnabled"
            />
            <label
              for="DisplayCTAbuttons"
              class="ml-2 checkbox-radio-font"
              id="displayCTAbuttons-tooltip"
              >{{ lmodel.ambDisplayCTAbuttons }}</label
            >
          </div>
          <div class="col-12 lg:col-6 custom-control">
            <RadioButton
              v-model="ambDisplayButton"
              id="enableChannelButtonAnimation"
              type="radio"
              value="1"
              :disabled="!isAnyChannelEnabled"
            />
            <label
              for="EnableChannelButtonAnimation"
              class="ml-2 checkbox-radio-font"
              id="enableChannelButtonAnimation-tooltip"
              v-tooltip="lmodel.ambEnableChannelButtonAnimationToolTip"
              >{{ lmodel.ambEnableChannelButtonAnimation }}</label
            >
          </div>
        </div>
        <div class="grid col-12">
          <div
            class="col-12 general-settings-text"
            v-if="
              vmodel.setHasFacebookChannel ||
              vmodel.setHasNativeMailChannel ||
              vmodel.setHasNativeSmsChannel ||
              vmodel.setHasWhatsappChannel ||
              vmodel.setHasSharebleLinkChannel ||
              vmodel.setHasTwitterChannel ||
              vmodel.setHasLineChannel ||
              vmodel.setHasKakaotalkChannel ||
              vmodel.setHasWebShareChannel ||
              vmodel.setHasSkypeChannel ||
              vmodel.setHasWeChatChannel ||
              vmodel.setHasDiscordChannel ||
              vmodel.setHasSignalChannel ||
              vmodel.setHasInstagramChannel ||
              vmodel.setHasTrueCallerChannel ||
              vmodel.setHasTelegramChannel ||
              vmodel.setHasPageShareChannel ||
              vmodel.setHasQRChannel
            "
          >
            <span>
              {{ lmodel.setChannelSetting }}
            </span>
          </div>
        </div>

        <!-- Messenger Settings -->
        <div
          class="grid col-12"
          id="Messenger"
          v-show="vmodel.setHasFacebookChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setMessengerSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setMessengerSettingsHelpText
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12 mt-2">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setMessengerTitleToolTip"
                tooltipvalueFor="messengerTitle-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setMessengerTitle }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.messengerTitle"
                PropName="Messenger Title"
                v-model="vmodel1.messengerTitle"
                id="MessengerTitle"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setMessengerTextToolTip"
                tooltipvalueFor="messengerText-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setMessengerText }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.messengerText"
                v-model="vmodel1.messengerText"
                PropName="Messenger Text"
                id="MessengerText"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- Messenger Settings End -->
        <div
          class="grid col-12"
          id="Email"
          v-show="vmodel.setHasNativeMailChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setEmailSetting
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setEmailSettingSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setEmailSubjectToolTip"
                tooltipvalueFor="emailSubject-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setEmailSubject }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.emailChannelSubject"
                PropName="Email Channel Subject"
                v-model="vmodel1.emailChannelSubject"
                id="EmailChannelSubject"
                class="mt-1"
                maxlength="200"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setEmailBodyToolTip"
                tooltipvalueFor="emailBody-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setEmailBody }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.emailChannelBody"
                PropName="Email Channel Body"
                v-model="vmodel1.emailChannelBody"
                id="EmailChannelBody"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- Native Mail End-->

        <!-- Native SMS -->
        <div
          class="grid col-12"
          id="SMS"
          v-show="vmodel.setHasNativeSmsChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setSMSSettingTitle
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setSMSSettingTitleSmall
            }}</span>
          </div>

          <div class="col-12">
            <label
              class="general-settings-label"
              v-tooltip="lmodel.setSMSBodyTitleToolTip"
              tooltipvalueFor="smsBodyTitle-tooltip"
              >{{ lmodel.setSMSBodyTitle }}</label
            >
            <Textarea
              v-model="vmodel1.smsChannelBody"
              class="mt-1"
              id="SmsChannelBody"
              autocomplete="off"
            ></Textarea>
          </div>
        </div>
        <!-- Native SMS End -->

        <!-- TrueCaller -->
        <div
          class="grid col-12"
          id="TrueCaller"
          v-show="vmodel.setHasTrueCallerChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setTrueCallerSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setTrueCallerSettingsSmall
            }}</span>
          </div>

          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setTrueCallerDescriptionToolTip"
                tooltipvalueFor="trueCallerDescription-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setTrueCallerDescription }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.trueCallerDescription"
                PropName="Description"
                v-model="vmodel1.trueCallerDescription"
                id="truecallerdescription"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setTrueCallerDescriptionPointerToolTip"
                tooltipvalueFor="truecallerDescriptionPointer-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setTrueCallerPointerDescription }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.trueCallerDescriptionPointer"
                PropName="Pointer Description "
                v-model="vmodel1.trueCallerDescriptionPointer"
                id="trueCallerdescriptionpointer"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- TrueCaller End-->

        <!-- Whatsapp -->
        <div
          class="grid col-12"
          id="Whatsapp"
          v-show="vmodel.setHasWhatsappChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setWhatsappSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setWhatsappSettingsSmall
            }}</span>
          </div>
          <div class="col-12 lg:col-12">
            <label
              class="general-settings-label"
              v-tooltip="lmodel.setWhatsappBodyMessageToolTip"
              tooltipvalueFor="whatsappBodyMessage-tooltip"
              :isRequiredLabel="true"
              >{{ lmodel.setWhatsappBodyMessage }}</label
            >
            <InputRequiredTextArea
              :validation="valmodel.whatsappChannelBody"
              v-model="vmodel1.whatsappChannelBody"
              id="WhatsappChannelBody"
              PropName="Whatsapp Channel Body"
              maxlength="200"
            ></InputRequiredTextArea>
          </div>
        </div>
        <!-- Whatsapp End-->

        <!-- Shareable Link -->
        <div
          class="grid col-12"
          id="SharebleLink"
          v-show="vmodel.setHasSharebleLinkChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setShareableLinkSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setShareableLinkSettingsSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setShareableLinkTitleToolTip"
                tooltipvalueFor="shareableLinkTitle-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setShareableLinkTitle }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.shareableLinkTitle"
                PropName="Shareable Link Title"
                v-model="vmodel1.shareableLinkTitle"
                id="ShareableLinkTitle"
                class="mt-1"
                maxlength="75"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setShareableLinkDescToolTip"
                tooltipvalueFor="shareableLinkDesc-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setShareableLinkDesc }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.shareableLinkDesc"
                PropName="Shareable Link Description"
                v-model="vmodel1.shareableLinkDesc"
                id="ShareableLinkDesc"
                maxlength="100"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setShareableLinkMessageToFriendsToolTip"
                tooltipvalueFor="shareableLinkMessageToFriends-tooltip"
                :isRequiredLabel="false"
                >{{ lmodel.setShareableLinkMessageToFriends }}</label
              >
              <InputRequiredTextArea
                v-model="vmodel1.shareableLinkMessageToFriends"
                id="ShareableLinkMessageToFriends"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- Shareable Link End -->

        <!-- Twitter -->
        <div
          class="grid col-12"
          id="Twitter"
          v-show="vmodel.setHasTwitterChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setTwitterSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setTwitterSettingsSmall
            }}</span>
          </div>

          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setTwitterChannelTitleToolTip"
                tooltipvalueFor="twitterChannelTitle-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setTwitterChannelTitle }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.twitterChannelTitle"
                PropName="Twitter Channel Title"
                v-model="vmodel1.twitterChannelTitle"
                id="TwitterChannelTitle"
                class="mt-1"
                maxlength="75"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setTwitterChannelDescToolTip"
                tooltipvalueFor="twitterChannelDesc-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setTwitterChannelDesc }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.twitterChannelDesc"
                v-model="vmodel1.twitterChannelDesc"
                PropName="Twitter Channel Description"
                id="TwitterChannelDesc"
                maxlength="100"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setTwitterBodyMessageToolTip"
                tooltipvalueFor="twitterBodyMessage-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setTwitterBodyMessage }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.twitterChannelBody"
                PropName="Twitter Channel Body"
                v-model="vmodel1.twitterChannelBody"
                id="TwitterChannelBody"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- Twitter End-->

        <!-- Telegram -->
        <div
          class="grid col-12"
          id="Telegram"
          v-show="vmodel.setHasTelegramChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setTelegramSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setTelegramSettingsSmall
            }}</span>
          </div>
          <div class="col-12">
            <label
              class="general-settings-label"
              v-tooltip="lmodel.setTelegramBodyMessageToolTip"
              tooltipvalueFor="telegramBodyMessage-tooltip"
              :isRequiredLabel="true"
              >{{ lmodel.setTelegramBodyMessage }}</label
            >
            <InputRequiredTextArea
              :validation="valmodel.telegramChannelBody"
              PropName="Telegram Channel Body"
              v-model="vmodel1.telegramChannelBody"
              id="TelegramChannelBody"
              maxlength="200"
              class="mt-1"
            ></InputRequiredTextArea>
          </div>
        </div>
        <!-- Telegram End-->

        <!-- Line -->
        <div class="grid col-12" id="Line" v-show="vmodel.setHasLineChannel">
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setLineSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setLineSettingsSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setLineChannelTitleToolTip"
                tooltipvalueFor="lineChannelTitle-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setLineChannelTitle }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.lineChannelTitle"
                v-model="vmodel1.lineChannelTitle"
                PropName="Line Channel Title"
                id="LineChannelTitle"
                maxlength="75"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setLineChannelDescToolTip"
                tooltipvalueFor="lineChannelDesc-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setLineChannelDesc }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.lineChannelDesc"
                v-model="vmodel1.lineChannelDesc"
                id="LineChannelDesc"
                PropName="Line Channel Description"
                maxlength="100"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setLineBodyMessageToolTip"
                tooltipvalueFor="lineBodyMessage-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setLineBodyMessage }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.lineChannelBody"
                v-model="vmodel1.lineChannelBody"
                id="LineChannelBody"
                PropName="Line Channel Body"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- Line End-->

        <!-- Kakaotalk -->
        <div
          class="grid col-12"
          id="Kakaotalk"
          v-show="vmodel.setHasKakaotalkChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setKakaotalkSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setKakaotalkSettingsSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setKakaotalkChannelWidgetTitleToolTip"
                tooltipvalueFor="kakaotalkChannelWidgetTitle-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setKakaotalkChannelWidgetTitle }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.kakaotalkChannelWidgetTitle"
                PropName="Kakaotalk Channel Widget Title"
                v-model="vmodel1.kakaotalkChannelWidgetTitle"
                id="KakaotalkChannelWidgetTitle"
                class="mt-1"
                maxlength="75"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setKakaotalkChannelWidgetDescToolTip"
                tooltipvalueFor="kakaotalkChannelWidgetDesc-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setKakaotalkChannelWidgetDesc }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.kakaotalkChannelWidgetDesc"
                PropName="Kakaotalk Channel Widget Description"
                v-model="vmodel1.kakaotalkChannelWidgetDesc"
                id="KakaotalkChannelWidgetDesc"
                maxlength="100"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setKakaotalkChannelTitleToolTip"
                tooltipvalueFor="kakaotalkChannelTitle-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setKakaotalkChannelTitle }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.kakaotalkChannelTitle"
                PropName="Kakaotalk Channel Title"
                v-model="vmodel1.kakaotalkChannelTitle"
                id="KakaotalkChannelTitle"
                class="mt-1"
                maxlength="75"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-6">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setKakaotalkButtonTextToolTip"
                tooltipvalueFor="kakaotalkButtonText-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setKakaotalkButtonText }}</label
              >
              <InputRequiredText
                :validation="valmodel.kakaotalkChannelButtonText"
                PropName="Kakaotalk Channel Button Text"
                v-model="vmodel1.kakaotalkChannelButtonText"
                id="KakaotalkChannelButtonText"
                class="mt-1"
                maxlength="30"
              ></InputRequiredText>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setKakaotalkChannelMessageToolTip"
                tooltipvalueFor="kakaotalkChannelMessage-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setKakaotalkChannelMessage }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.kakaotalkChannelBody"
                PropName="Kakaotalk Channel Body"
                v-model="vmodel1.kakaotalkChannelBody"
                id="KakaotalkChannelBody"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- Kakaotalk End-->

        <!-- WebShare -->
        <div
          class="grid col-12"
          id="Kakaotalk"
          v-show="vmodel.setHasWebShareChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setWebShareSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setWebShareSettingsSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setWebShareTitleToolTip"
                tooltipvalueFor="webShareTitle-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setWebShareTitle }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.webShareTitle"
                PropName="Web Share Channel Title"
                v-model="vmodel1.webShareTitle"
                id="webShareTitle"
                class="mt-1"
                maxlength="200"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setWebShareBodyToolTip"
                tooltipvalueFor="webShareBody-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setWebShareBody }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.webShareBody"
                PropName="Web Share Channel Body"
                v-model="vmodel1.webShareBody"
                id="webShareBody"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- WebShare End-->

        <!-- QR -->
        <div class="grid col-12" id="QR" v-show="vmodel.setHasQRChannel">
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setQRSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setQRSettingsSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setQRheaderToolTip"
                tooltipvalueFor="qRheader-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setQRheader }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.qRheader"
                PropName="QR Header"
                v-model="vmodel1.qRheader"
                id="qRheader"
                class="mt-1"
                maxlength="75"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setQRbodyToolTip"
                tooltipvalueFor="qRbody-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setQRbody }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.qRbody"
                PropName="QR Body"
                v-model="vmodel1.qRbody"
                id="qRbody"
                maxlength="100"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- QR End-->

        <!-- Page Share -->
        <div
          class="grid col-12"
          id="PageShareing"
          v-show="vmodel.setHasPageShareChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setPageShareSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setPageShareSettingsSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setPageShareDescriptionToolTip"
                tooltipvalueFor="pageShareDescription-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setPageShareDescription }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.pageShareDescription"
                PropName="Page Share Channel Description"
                v-model="vmodel1.pageShareDescription"
                id="pageShareDescription"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setPageShareDescriptionPointerToolTip"
                tooltipvalueFor="pageShareDescriptionPonter-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setPageShareDescriptionPointer }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.pageShareDescriptionPointer"
                PropName="Page Share Channel Description Pointer"
                v-model="vmodel1.pageShareDescriptionPointer"
                id="pageShareDescriptionPointer"
                maxlength="200"
                class="mt-1"
                :placeholder="lmodel.setPageShareDescriptionPointerPlaceholder"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- Page Share End-->

        <!-- Skype -->
        <div
          class="grid col-12"
          id="PageShareing"
          v-show="vmodel.setHasSkypeChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setSkypeSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setSkypeSettingsSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setSkypeTitleToolTip"
                tooltipvalueFor="skypeTitle-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setSkypeTitle }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.skypeTitle"
                PropName="Skype Channel Title"
                v-model="vmodel1.skypeTitle"
                id="skypeTitle"
                class="mt-1"
                maxlength="200"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setSkypeTextToolTip"
                tooltipvalueFor="skypeText-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setSkypeText }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.skypeText"
                PropName="Skype Channel Text"
                v-model="vmodel1.skypeText"
                id="skypeText"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- Skype End-->

        <!-- WeChat -->
        <div
          class="grid col-12"
          id="WeChat"
          v-show="vmodel.setHasWeChatChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setWeChatSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setWeChatSettingsSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setWeChatDescriptionToolTip"
                tooltipvalueFor="weChatDescription-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setWeChatDescription }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.wechatdescription"
                PropName="Description Text"
                :placeholder="lmodel.setWeChatDescriptionPlaceholder"
                v-model="vmodel1.wechatdescription"
                id="wechatdescription"
                class="mt-1"
                maxlength="200"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setWeChatDescriptionPointerToolTip"
                tooltipvalueFor="weChatDescriptionPointer-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setWeChatPointerDescription }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.wechatdescriptionpointer"
                PropName="Description Text"
                :placeholder="lmodel.setWeChatDescriptionPointerPlaceholder"
                v-model="vmodel1.wechatdescriptionpointer"
                id="wechatdescriptionpointer"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- WeChat End-->

        <!-- Instagram -->
        <div
          class="grid col-12"
          id="Instagram"
          v-show="vmodel.setHasInstagramChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setInstagramSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setInstagramSettingsSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setInstagramDescriptionToolTip"
                tooltipvalueFor="instagramDescription-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setInstagramDescription }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.instagramdescription"
                PropName="Description Text 1"
                :placeholder="lmodel.setInstagramDescriptionPlaceholder"
                v-model="vmodel1.instagramdescription"
                id="instagramdescription"
                class="mt-1"
                maxlength="200"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setInstagramDescriptionPointerToolTip"
                tooltipvalueFor="instagramDescriptionPointer-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setInstagramPointerDescription }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.instagramdescriptionpointer"
                PropName="Description Text 2"
                :placeholder="lmodel.setInstagramDescriptionPointerPlaceholder"
                v-model="vmodel1.instagramdescriptionpointer"
                id="instagramdescriptionpointer"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- Instagram End-->

        <!-- Discord -->
        <div
          class="grid col-12"
          id="Discord"
          v-show="vmodel.setHasDiscordChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setDiscordSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setDiscordSettingsSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setDiscordDescriptionToolTip"
                tooltipvalueFor="discordDescription-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setDiscordDescription }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.discorddescription"
                PropName="Description Text 1"
                :placeholder="lmodel.setDiscordDescriptionPlaceholder"
                v-model="vmodel1.discorddescription"
                id="discorddescription"
                class="mt-1"
                maxlength="200"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setDiscordDescriptionPointerToolTip"
                tooltipvalueFor="discordDescriptionPointer-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setDiscordPointerDescription }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.discorddescriptionpointer"
                PropName="Description Text"
                :placeholder="lmodel.setDiscordDescriptionPointerPlaceholder"
                v-model="vmodel1.discorddescriptionpointer"
                id="discorddescriptionpointer"
                maxlength="200"
                class="mt-1"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- Discord End-->

        <!-- Signal -->
        <div
          class="grid col-12"
          id="Signal"
          v-show="vmodel.setHasSignalChannel"
        >
          <div class="col-12">
            <span class="general-settings-text">{{
              lmodel.setSignalSettings
            }}</span>
            <br />
            <span class="general-settings-text">{{
              lmodel.setSignalSettingsSmall
            }}</span>
          </div>
          <div class="grid col-12">
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setSignalDescriptionToolTip"
                tooltipvalueFor="signalDescription-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setSignalDescription }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.signaldescription"
                PropName="Description Text 1"
                :placeholder="lmodel.setSignalDescriptionPlaceholder"
                v-model="vmodel1.signaldescription"
                id="signaldescription"
                class="mt-1"
                maxlength="200"
              ></InputRequiredTextArea>
            </div>
            <div class="col-12 lg:col-12">
              <label
                class="general-settings-label"
                v-tooltip="lmodel.setSignalDescriptionPointerToolTip"
                tooltipvalueFor="signalDescriptionPointer-tooltip"
                :isRequiredLabel="true"
                >{{ lmodel.setSignalPointerDescription }}</label
              >
              <InputRequiredTextArea
                :validation="valmodel.signaldescriptionpointer"
                PropName="Description Text"
                :placeholder="lmodel.setSignalDescriptionPointerPlaceholder"
                v-model="vmodel1.signaldescriptionpointer"
                id="signaldescriptionpointer"
                class="mt-1"
                maxlength="200"
              ></InputRequiredTextArea>
            </div>
          </div>
        </div>
        <!-- Signal End-->
      </div>

      <div
        :class="
          !isDisabled
            ? 'header-edit-mode text-right button-container'
            : 'head-mode text-right button-container'
        "
      >
        <PrimeButton
          id="cancelbtn"
          @click="cancelBtn()"
          type="button"
          name="Cancel"
          value="cancel"
          label="Cancel"
          class="cancel-btnadd"
        />
        <PrimeButton
          label="Save"
          class="save-btn1 ml-2 mr-2"
          icon="save-icon"
          @click="saveReferral()"
        ></PrimeButton>
      </div>
    </div>
  </div>
</template>

<script>
import staticData from "@/staticdata/static.json";

export default {
  components: {},

  props: {
    dealId: {
      type: String,
      default: null,
    },
    isCancelClick: {
      type: Boolean,
      default: false,
    },
    tabId: {
      type: Number,
      default: 0,
    },
    lmodel: {
      type: Object,
      default: null,
    },
    dmodel: {
      type: Object,
      default: null,
    },
    vmodel: {
      type: Object,
      default: null,
    },
    valmodel: {
      type: Object,
      default: null,
    },
    dealStatus: {
      type: Number,
      default: null,
    },
    isRedealText: {
      type: Boolean,
      default: false,
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null,
    },
    modelstate: {
      type: Object,
      default: null,
    },
    disableReferral: {
      type: Boolean,
      default: false,
    },
    isReferrals: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      staticData: staticData,
      isSave: false,
      ambDisplayButton: false,
      id: this.$route.params.id,
    };
  },
  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },

    isAnyChannelEnabled() {
      return (
        this.vmodel.setHasFacebookChannel ||
        this.vmodel.setHasNativeMailChannel ||
        this.vmodel.setHasNativeSmsChannel ||
        this.vmodel.setHasWhatsappChannel ||
        this.vmodel.setHasSharebleLinkChannel ||
        this.vmodel.setHasTwitterChannel ||
        this.vmodel.setHasLineChannel ||
        this.vmodel.setHasKakaotalkChannel ||
        this.vmodel.setHasWebShareChannel ||
        this.vmodel.setHasSkypeChannel ||
        this.vmodel.setHasWeChatChannel ||
        this.vmodel.setHasDiscordChannel ||
        this.vmodel.setHasSignalChannel ||
        this.vmodel.setHasInstagramChannel ||
        this.vmodel.setHasTrueCallerChannel ||
        this.vmodel.setHasTelegramChannel ||
        this.vmodel.setHasPageShareChannel ||
        this.vmodel.setHasQRChannel
      );
    },
  },
  mounted() {},
  created() {},

  methods: {
    cancelBtn() {
      this.$emit("cancel");
    },
    saveReferral() {
      this.$emit("call");

      this.isSave = true;
    },
  },
};
</script>

<style lang="scss" scoped>
input:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

.p-button:enabled:hover {
  background-color: #2d6e6d;
  border-color: #2d6e6d;
  color: #fff;
}

input {
  color: #777 !important;
  font-size: 0.8rem;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext) {
  color: #21211f !important;
  font-size: 16px;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
  resize: none;
}
:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}

.checkbox-radio-font {
  font-size: 14.22px;
}

.toggle-button {
  display: flex;
  align-items: center;
}

.toggle-button span {
  cursor: pointer;
  vertical-align: middle;
}

.line-text {
  align-items: center;
  padding: 0px 32px 0px 32px !important;
}
.line-text-2 {
  align-items: center;
  padding: 0px 32px 15px 32px;
}

.button-container {
  padding: 26px 40px 26px 40px;
}

:deep(.p-button:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}

:deep(.heading-text) {
  height: 19px;
  font-family: "Voyado Text";
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
  text-align: left;
  color: #21211f;
}
.container-text {
  font-family: "Voyado Text";
  font-size: 14.22px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
  color: #21211f;
}
.btn-change {
  background-color: #2d6e6d;
  border-color: #2d6e6d;
  color: #fff;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
}

.header-edit-mode {
  background-color: #f8f8f7 !important;
}

.head-mode {
  background-color: #fff !important;
}

:deep(.control-label) {
  font-size: 14.22px;
}

.general-settings-label {
  font-size: 14.22px !important;
  font-weight: 400 !important;
  line-height: 17.1px !important;
  color: #666666;
  font-family: "Voyado Text";
  // text-align: left;
}

.general-settings-text {
  font-size: 14.22px !important;
  font-weight: 500 !important;
  line-height: 17.1px !important;
  color: #21211f !important;
  // text-align: left;
}

:deep(.textareaBody) {
  height: 90px !important;
  .p-inputtextarea {
    height: 90px !important;
  }
}
</style>
